import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import app from 'new-ui/app';

export const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  const value = useMemo(() => ({
    alert,
    showAlert: setAlert,
    hideAlert: () => setAlert(null),
  }), [alert]);

  // due to some code still uses it
  app.alert = setAlert;

  return (
    <AlertContext.Provider value={value}>
      {children}
    </AlertContext.Provider>
  );
};

AlertProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
